var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icons",
    width: 24,
    height: 25,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9997 3.23486V6.03486C21.6686 6.97845 23.9179 8.83514 25.3502 11.2768C26.7825 13.7184 27.3056 16.5878 26.8269 19.3778C26.3482 22.1678 24.8986 24.6987 22.7344 26.5233C20.5701 28.3479 17.8305 29.3486 14.9997 29.3486C12.169 29.3486 9.42935 28.3479 7.26507 26.5233C5.10079 24.6987 3.65121 22.1678 3.17253 19.3778C2.69384 16.5878 3.21687 13.7184 4.64918 11.2768C6.08149 8.83514 8.33085 6.97845 10.9997 6.03486V3.23486C7.59387 4.20033 4.65215 6.36506 2.71737 9.3296C0.782592 12.2941 -0.0146674 15.8584 0.472706 19.3648C0.96008 22.8711 2.6992 26.0828 5.36914 28.4073C8.03908 30.7318 11.4597 32.0122 14.9997 32.0122C18.5398 32.0122 21.9603 30.7318 24.6303 28.4073C27.3002 26.0828 29.0393 22.8711 29.5267 19.3648C30.0141 15.8584 29.2168 12.2941 27.2821 9.3296C25.3473 6.36506 22.4056 4.20033 18.9997 3.23486Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3327 0H13.666V10.6667H16.3327V0Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6edd1205c4e785aee41827417e444a06.svg";
export { ForwardRef as ReactComponent };